import oneUxSpacing from '../../../../generated/json/spacing/spacing.json';
export const cardBaseIndentation = oneUxSpacing[300];